import { render, staticRenderFns } from "./SaleAmount.vue?vue&type=template&id=2d128c2b&scoped=true"
import script from "./SaleAmount.vue?vue&type=script&lang=js"
export * from "./SaleAmount.vue?vue&type=script&lang=js"
import style0 from "./SaleAmount.vue?vue&type=style&index=0&id=2d128c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d128c2b",
  null
  
)

export default component.exports